import React from 'react';
import ColAtm from "../../../../atomic/Col/Col";
import {PageTitle} from "../../../../atomic/PageHeader/PageTitle";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import PageHeaderAtm from "../../../../atomic/PageHeader/PageHeader";
import {NETWORK_COUPONS_CHANNEL_LIST, BOOKING_ENGINE} from "../../../../../constants/appUrls.constants";
import { withRouter } from "react-router-dom";

let t=null;


class CouponHeader extends React.Component{
    constructor(props) {
        super(props);
        t = props.t;
    }

    render() {
        const isFromBookingEngine = this.props.location?.state?.fromBookingEngine === true;

        const backButtonUrl = isFromBookingEngine ? BOOKING_ENGINE : NETWORK_COUPONS_CHANNEL_LIST;
        const exitText = isFromBookingEngine ? t('be-search-booking_engine-title') : t('btn-dashboard')
        return (
            <>
                <ColAtm>
                    <PageTitle title={ t('title-coupons-header-text') } />
                    <PageHeaderAtm backButton={backButtonUrl}
                                   exitText= {exitText}
                                   text={ t('title-coupons-header-text') }
                    />
                </ColAtm>
            </>
        )
    }
}

export default compose(withTranslation('common'), withRouter) (CouponHeader);
